module.exports = __webpack_public_path__ + "static/fabrica-slide1-097c4203f1cba2ee11faaa93ffec6e22.jpg";